module.exports = __webpack_public_path__ + "static/dartmouth.b407e971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dartmouth.png
// module id = 98
// module chunks = 35783957827783 83016852698721 251955352258861